import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import googleLogo from 'images/logos/google.png';
import microsoftLogo from 'images/logos/microsoft.png';
import DraggableDialogPaperComponent from '../../common/components/DraggableDialogPaperComponent';
import InjectStore from '../../common/utils/InjectStore';
import { CircularProgress } from '@material-ui/core';
import styled from "styled-components";
import GoogleButton from 'react-google-button';


const SelectEmailDialog = (props) => {
  const { store } = props;

  return (
    <div>
      <Dialog
        open={store.currentState == "email-type"}
        // onClose={handleClose}
        PaperComponent={DraggableDialogPaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {store.isLoading ? "Fetch Emails" : "Select email provider"}
        </DialogTitle>
        <DialogContent>
          {store.isLoading ?
            <CircularProgress disableShrink />
            :
            <StyledDialogContentText>
              {/* <Button color="primary" onClick={store.handleEmailTypeClick.bind(store, "google")}>
                <img className="tiger_logo" width={100} style={{ cursor: "pointer" }} src={googleLogo} />
              </Button> */}
              <GoogleButton
                type="dark"
                onClick={store.handleEmailTypeClick.bind(store, "google")}
              />
              <StyledMicrosoftButton color="primary" onClick={store.handleEmailTypeClick.bind(store, "microsoft")}>
                <img className="tiger_logo" width={100} style={{ cursor: "pointer" }} src={microsoftLogo} />
              </StyledMicrosoftButton>
            </StyledDialogContentText>
          }

        </DialogContent>
        <DialogActions>
          <Button onClick={store.handleClose} color="primary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

const StyledMicrosoftButton = styled(Button)`
&& {
  margin-left: 10px;
}
`;

const StyledDialogContentText = styled(DialogContentText)`
&& {
  display: flex;
  align-items: center;
}
`;
export default InjectStore(SelectEmailDialog);